import { Options as ButtonsOptions } from '@flatsy/core/Form/ReactFormHooks/Field/Buttons/Type'
import { FormValue } from '@flatsy/types/Applications'
import i18n from '@flatsy/utils/translations'

export const renderGuarantorType = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('family'),
      value: FormValue.guarantorType.FAMILY,
    },
    {
      label: i18n.t('friend'),
      value: FormValue.guarantorType.FRIEND,
    },
    {
      label: i18n.t('visale'),
      value: FormValue.guarantorType.VISALE,
    },
    {
      label: i18n.t('your_company'),
      value: FormValue.guarantorType.COMPANY_BANK,
    },
    {
      label: i18n.t('online_guarantor'),
      value: FormValue.guarantorType.ONLINE_SERVICE,
    },
  ]
}
